import {InjectionToken} from "@angular/core";
import {Prior, ProReportDetails} from "../../model/pro-report/HeaderDetails";
import {NotificationWindowDetails} from "./notification-window";
import {RecentSearch} from "../../model/RecentSearch";

export const ObligorId_INJECTION_TOKEN = new InjectionToken<string>('obligorId');
export const State_INJECTION_TOKEN = new InjectionToken<string>('state');
export const ProReportDetails_INJECTION_TOKEN = new InjectionToken<ProReportDetails>('state');
export const Prior_INJECTION_TOKEN = new InjectionToken<Prior>('prior');
export const Notification_Window_TOKEN = new InjectionToken<NotificationWindowDetails>('');
export const String_INJECTION_TOKEN = new InjectionToken<string>('any string');
export const Related_Doc_Type_INJECTION_TOKEN = new InjectionToken<"CD" | "ME">('CD or ME');
export const RecentSearch_TOKEN = new InjectionToken<RecentSearch>('');
